import mixins from 'vue-typed-mixins';

import 勘定科目ListEditMixin from '@/components/勘定科目/listEdit/勘定科目ListEditMixin';

export default mixins(勘定科目ListEditMixin).extend({
  name: 'C勘定科目ListEditModeToggleButton',

  computed: {
    label(): string {
      return this.is勘定科目ListEditMode ? '通常モード' : '勘定科目編集モード';
    },
  },
});
